import { render, staticRenderFns } from "./ChoosePreset.vue?vue&type=template&id=0cbe5978&scoped=true&"
import script from "./ChoosePreset.vue?vue&type=script&lang=js&"
export * from "./ChoosePreset.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePreset.vue?vue&type=style&index=0&id=0cbe5978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe5978",
  null
  
)

export default component.exports